import React from "react";
import { View, Text, ViewStyle, TextStyle } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Image } from "expo-image";
import { FontFamilies, Typography } from "@/constants/Typography";

interface StatusItem {
  icon?: React.ReactNode;
  text: string;
  color?: string;
}

interface FlightCardProps {
  amount?: string;
  amountColor?: string;
  title: string;
  logo?: React.ReactNode;
  status?: StatusItem[];
  style?: ViewStyle;
  titleStyle?: TextStyle;
  children?: React.ReactNode;
}

const FlightCard: React.FC<FlightCardProps> = ({
  amount,
  amountColor = "#A3F2A3",
  title,
  logo,
  status = [],
  style,
  titleStyle,
  children,
}) => {
  return (
    <View style={[styles.card, style]}>
      <View style={styles.topRow}>
        <View style={{ flex: 1 }}>
          {amount && (
            <View style={[styles.amountPill, { backgroundColor: amountColor }]}>
              <Text style={styles.amountText}>{amount}</Text>
            </View>
          )}
          {children}
          {title && <Text style={[styles.title, titleStyle]}>{title}</Text>}
        </View>
        <View style={styles.logoBox}>{logo}</View>
      </View>
      {status.length > 0 && (
        <View style={styles.statusRow}>
          {status.map((item, idx) => (
            <View key={idx} style={styles.statusItem}>
              {item.icon && <View style={{ marginRight: 4 }}>{item.icon}</View>}
              <Text
                style={[
                  styles.statusText,
                  item.color ? { color: item.color } : {},
                ]}
              >
                {item.text}
              </Text>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

export default FlightCard;

const styles = StyleSheet.create({
  card: {
    width: "90%",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    marginBottom: 16,
    paddingLeft: 16,
    paddingBottom: 16,
    borderWidth: 1,
    borderColor: "#FFFFFF33",
  },
  topRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.08)",
  },
  amountPill: {
    alignSelf: "flex-start",
    borderRadius: 120,
    paddingHorizontal: 11,
    paddingVertical: 8,
    marginBottom: 8,
  },
  amountText: {
    color: "#222",
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 10,
  },
  title: {
    color: "#fff",
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 15,
  },
  logoBox: {
    width: 120,
    height: 120,
    backgroundColor: "#00000033",
    justifyContent: "center",
    alignItems: "center",
    borderTopRightRadius: 16,
  },
  statusRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 24,
    marginTop: 4,
  },
  statusItem: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 16,
  },
  statusText: {
    flexShrink: 1,
    color: "white",
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 13,
    marginLeft: 4,
  },
});
